import axios from 'axios';
import { header } from './header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

/**
 * Récupère les commandes Dolibarr (bridge backend).
 * @param {string} dolapikey
 */
export const fetchDolibarrOrders = async (dolapikey) => {
  try {
    const res = await axios.post(
      `${API_URL}/dolibarr/orders`,
      { dolapikey },
      header()
    );
    return res.data;
  } catch (e) {
    console.error('fetchDolibarrOrders error:', e?.response?.data || e.message);
    throw e;
  }
};

/**
 * Récupère les commandes agrégées par type de produit (ex: 'CarrefourGlobal').
 * @param {string} productType
 * @param {string} dolapikey
 */
export const fetchOrdersByProductType = async (productType, dolapikey) => {
  try {
    const res = await axios.get(
      `${API_URL}/orders/productType/${encodeURIComponent(productType)}`,
      {
        ...header(),
        params: { dolapikey },
      }
    );
    return res.data;
  } catch (e) {
    console.error('fetchOrdersByProductType error:', e?.response?.data || e.message);
    throw e;
  }
};

/**
 * Crée une facture dans Dolibarr avec les lignes passées.
 * @param {object} invoice
 * @param {string} dolapikey
 */
export const createDolibarrInvoice = async (invoice, dolapikey) => {
  try {
    const res = await axios.post(
      `${API_URL}/dolibarr/invoices`,
      { dolapikey, invoice },
      header()
    );
    return res.data;
  } catch (e) {
    console.error('createDolibarrInvoice error:', e?.response?.data || e.message);
    throw e;
  }
};

/**
 * Met à jour l'utilisateur associé à une commande Dolibarr.
 * @param {string} orderIdRaw
 * @param {string} userId
 */
export const updateDolibarrOrderUser = async (orderIdRaw, userId) => {
  try {
    const res = await axios.patch(
      `${API_URL}/dolibarr/order/${orderIdRaw}/request-context/user`,
      { user_id: userId },
      header()
    );
    return res.data;
  } catch (e) {
    console.error('updateDolibarrOrderUser error:', e?.response?.data || e.message);
    throw e;
  }
};

export default {
  fetchDolibarrOrders,
  fetchOrdersByProductType,
  createDolibarrInvoice,
  updateDolibarrOrderUser,
};
